import React from 'react'
import { useNavigate } from "react-router-dom";

function Category() {

  const categoryImages = [
   {name:'Shirt',image: 'snitch-store009.jpg'},
   {name:'T-Shirt',image:'snitch-store010.jpg'},
   {name:'jeans',image:'snitch-store011.jpg'},
   {name:'pants',image:'snitch-store012.jpg'},
   {name:'Shorts',image:'snitch-store013.jpg'},
   {name:'Coords',image:'snitch-store014.jpg'},
   {name:'Jacket',image:'snitch-store015.jpg'},
   {name:'Inner',image:'snitch-store016.jpg'},
   {name:'shoes',image:'snitch-store017.webp'},
   {name:'Perfume',image:'snitch-store018.jpg'},
   {name:'Sunglasses',image:'snitch-store019.jpg'},
   {name:'Accessories',image:'snitch-store020.webp'}

    ]

    const navigate = useNavigate();

    const handleClick = (category) => {
      // navigate("/products");
      navigate(`/products?search=${encodeURIComponent(category)}`);

    };
    
  return (
    <section id='category' className="flex justify-center items-center w-full category-container">
        <div className="flex justify-self-start items-center gap-2 p-2 pb-2 overflow-x-auto">
            {categoryImages.map((item,index) => {
             return <img onClick={ () => handleClick(item.name)} key={index} src={`/assets/category/${item.image}`} style={{width:'100px'}}  className='cursor-pointer' alt={`Category${index}`} />
             
            })}
        </div>
    </section>
  )
}

export default Category